import { render, staticRenderFns } from "./PeerOk.vue?vue&type=template&id=2488e32f&"
import script from "./PeerOk.vue?vue&type=script&lang=js&"
export * from "./PeerOk.vue?vue&type=script&lang=js&"
import style0 from "./PeerOk.vue?vue&type=style&index=0&id=2488e32f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports